import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormFieldSelectComponent } from 'src/app/lib/form-fields/form-field-select';
import {
  SelectOptionGroup,
  SelectOptionWithGroup,
  Supervision,
} from 'src/app/types';

@Component({
  selector: 'app-form-field-selection-test-location',
  templateUrl:
    './form-field-selection-test-location.component.html',
})
export class FormFieldSelectionTestLocationComponent
  extends FormFieldSelectComponent
  implements OnInit, AfterViewInit
{
  @Input() focused = false;
  @ViewChild('autoFocusInput')
  autoFocusInputRef!: NgSelectComponent;

  isProctoringOption!: boolean;
  flatOptions: SelectOptionWithGroup[] = [];

  ngOnInit(): void {
    this.isProctoringOption = this.options.some(
      (option) =>
        option.supervision === Supervision.Proctoring
    );

    if (this.isProctoringOption) {
      const optionGroups: SelectOptionGroup[] = [
        {
          groupName:
            'label.exam-location.supervision.in-person',
          options: this.options.filter(
            (location) =>
              location.supervision ===
              Supervision.Testcenter
          ),
        },
        {
          groupName:
            'label.exam-location.supervision.proctoring',
          options: this.options.filter(
            (location) =>
              location.supervision ===
              Supervision.Proctoring
          ),
        },
      ];

      this.flatOptions = optionGroups.flatMap((group) =>
        group.options.map((opt) => ({
          ...opt,
          groupName: group.groupName,
        }))
      );
    } else {
      this.flatOptions = this.options;
    }
  }

  ngAfterViewInit(): void {
    if (this.focused && this.autoFocusInputRef) {
      setTimeout(() => {
        this.autoFocusInputRef.focus();
      }, 0);
    }
  }

  get showError(): boolean {
    return this.field.touched && !this.field.valid;
  }
}
